import { render } from "./STDSCM01C02LoginConfrimModal.vue?vue&type=template&id=6976c636"
import script from "./STDSCM01C02LoginConfrimModal.vue?vue&type=script&lang=js"
export * from "./STDSCM01C02LoginConfrimModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__